import React from "react";
import { Link } from "react-router-dom";
import { fmtEur } from "@/components/admin/ui-lite";

const STATUS = {
  proposee: ["Proposée", "border-sky-300/40 text-sky-200"],
  confirmee: ["Confirmée", "border-emerald-300/40 text-emerald-200"],
  retiree: ["Retirée", "border-white/20 text-white/45 line-through"],
};

export function DevisLinesSummary({ lines, devis }) {
  if (!devis) return null;
  const active = lines.filter((l) => l.status !== "retiree");
  const total = active.reduce((s, l) => s + (l.total || 0), 0);
  return (
    <div className="mt-4 overflow-x-auto" data-testid="rental-devis-lines">
      <p className="text-[10px] uppercase tracking-[0.18em] text-white/45 mb-2">
        Matériel, options et frais — lus depuis le devis <Link to={`/admin/devis/${devis.id}`} className="text-[#DCB457] underline underline-offset-2">{devis.number}</Link>
        {devis.is_signed ? " (signé, figé)" : " (modifiable jusqu'à signature)"}
      </p>
      <table className="w-full text-sm min-w-[560px]">
        <thead><tr className="text-[10px] uppercase tracking-[0.14em] text-white/40 text-left">
          <th className="py-1.5 font-normal">Libellé</th><th className="font-normal text-right">Qté</th><th className="font-normal text-right">Prix unit. TTC</th><th className="font-normal text-right">Total TTC</th><th className="font-normal text-right">Statut</th>
        </tr></thead>
        <tbody>
          {lines.map((l, n) => {
            const [label, cls] = STATUS[l.status] || STATUS.proposee;
            return (
              <tr key={`${l.description}-${n}`} className={`border-t border-white/5 ${l.status === "retiree" ? "text-white/40" : ""}`} data-testid={`rental-line-${n}`}>
                <td className="py-2 pr-3" data-testid={`rental-line-desc-${n}`}>{l.kind === "option" && <span className="text-[9px] uppercase tracking-[0.14em] text-[#DCB457] mr-2">Option</span>}{l.description}</td>
                <td className="text-right" data-testid={`rental-line-qty-${n}`}>{l.quantity ?? "—"}</td>
                <td className="text-right">{l.unit_price == null ? "—" : fmtEur(l.unit_price)}</td>
                <td className="text-right" data-testid={`rental-line-total-${n}`}>{l.total == null ? "—" : fmtEur(l.total)}</td>
                <td className="text-right"><span className={`text-[10px] uppercase tracking-[0.12em] border px-2 py-0.5 ${cls}`} data-testid={`rental-line-status-${n}`}>{label}</span></td>
              </tr>
            );
          })}
        </tbody>
        <tfoot><tr className="border-t border-white/15"><td colSpan={3} className="py-2 text-right text-white/55">Total des lignes (avant remise éventuelle)</td><td className="text-right gold-text" data-testid="rental-lines-total">{fmtEur(total)}</td><td className="text-right text-xs text-white/45" data-testid="rental-devis-total">Devis : {fmtEur(devis.total_ttc)}</td></tr></tfoot>
      </table>
    </div>
  );
}
